import script from "./routesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./routesView.vue?vue&type=script&setup=true&lang=ts"

import "./routesView.vue?vue&type=style&index=0&id=ab01c790&lang=css"

const __exports__ = script;

export default __exports__